import type {
  DemoSignalCardData,
  DemoSignalSeverity,
} from "@/lib/types/demo-session";

function isSeverity(value: unknown): value is DemoSignalSeverity {
  return value === "high" || value === "medium" || value === "low";
}

function requiredString(value: unknown): string | null {
  return typeof value === "string" && value.trim() ? value : null;
}

/** Trust boundary: drops malformed wire cards. */
export function mapWireDemoSignal(raw: unknown): DemoSignalCardData | null {
  if (!raw || typeof raw !== "object") return null;
  const r = raw as Record<string, unknown>;

  const signalKey = requiredString(r.signal_key);
  const beatKey = requiredString(r.beat_key);
  const title = requiredString(r.title);
  const body = requiredString(r.body);
  const avatarLine = requiredString(r.avatar_line);
  const firedAt = requiredString(r.fired_at);

  if (
    !signalKey ||
    !beatKey ||
    !title ||
    !body ||
    !avatarLine ||
    !firedAt ||
    !isSeverity(r.severity) ||
    !Number.isFinite(Date.parse(firedAt))
  ) {
    return null;
  }

  return {
    signalKey,
    beatKey,
    severity: r.severity,
    title,
    body,
    suggestedLine: requiredString(r.suggested_line),
    avatarLine,
    firedAt,
  };
}
